const mutations = {
  
    ADD_CURSO (state, curso) {

        state.cursos.push(curso)

    },

    ALL_CURSOS (state, value) {

        state.cursos = value

    },
}

export default mutations